/**
 * i18n工具函数，用于在普通JS文件中使用i18n
 */

// 获取翻译文本
export function t(key, params = {}) {
  if (window.$i18n) {
    return window.$i18n.t(key, params);
  }
  return key; // 如果没有i18n实例，则返回key
}

// 获取当前语言
export function getCurrentLocale() {
  if (window.$i18n) {
    return window.$i18n.locale;
  }
  return 'cn'; // 默认返回中文
}

// 切换语言
export function setLocale(locale) {
  if (window.$i18n) {
    window.$i18n.locale = locale;
    // 更新localStorage
    const langMap = {
      'cn': 'zh_CN',
      'en': 'en_US'
    };
    localStorage.setItem('lang', langMap[locale] || 'zh_CN');
    return true;
  }
  return false;
} 


// WEBPACK FOOTER //
// ./src/assets/js/i18n-helper.js